import { render, staticRenderFns } from "./dictionary-management.vue?vue&type=template&id=3c5e004e&scoped=true&"
import script from "./dictionary-management.vue?vue&type=script&lang=js&"
export * from "./dictionary-management.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-management.vue?vue&type=style&index=0&id=3c5e004e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e004e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5e004e')) {
      api.createRecord('3c5e004e', component.options)
    } else {
      api.reload('3c5e004e', component.options)
    }
    module.hot.accept("./dictionary-management.vue?vue&type=template&id=3c5e004e&scoped=true&", function () {
      api.rerender('3c5e004e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-system-management/dictionary-management.vue"
export default component.exports